import _defineProperty from "E:/Prydwen Website/annwyn/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "E:/Prydwen Website/annwyn/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "E:/Prydwen Website/annwyn/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["bsPrefix", "className", "as", "active", "eventKey"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import * as React from 'react';
import Anchor from '@restart/ui/Anchor';
import { useNavItem } from '@restart/ui/NavItem';
import { makeEventKey } from '@restart/ui/SelectableContext';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  disabled: false
};
var NavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? Anchor : _ref$as,
      active = _ref.active,
      eventKey = _ref.eventKey,
      props = _objectWithoutProperties(_ref, _excluded);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'nav-link');

  var _useNavItem = useNavItem(_objectSpread({
    key: makeEventKey(eventKey, props.href),
    active: active
  }, props)),
      _useNavItem2 = _slicedToArray(_useNavItem, 2),
      navItemProps = _useNavItem2[0],
      meta = _useNavItem2[1];

  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread(_objectSpread({}, props), navItemProps), {}, {
    ref: ref,
    className: classNames(className, bsPrefix, props.disabled && 'disabled', meta.isActive && 'active')
  }));
});
NavLink.displayName = 'NavLink';
NavLink.defaultProps = defaultProps;
export default NavLink;